import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/book_list_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  keyword: {
    model_name: 'BookList',
    column_type: 'string',
    column_name: 'title',
  },
}
export const formColumnsConfig = {
  'self': {
    'title': { required: true, disabledUpdate: false },
    'content_type': { required: true, disabledUpdate: false },
    'content': { required: false, disabledUpdate: false },
    'markdown_content': { required: false, disabledUpdate: false },
    'cover': { required: true, disabledUpdate: false },
    'share_desc': { required: false, disabledUpdate: false },
    'recommend_post_ids': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('BookList', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('BookList', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
